// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3xZOC","footer":"Form_footer__2EKEb"};